import { render, staticRenderFns } from "./VesselInfoContentLoader.vue?vue&type=template&id=f49aefb0&scoped=true&"
import script from "./VesselInfoContentLoader.vue?vue&type=script&lang=ts&"
export * from "./VesselInfoContentLoader.vue?vue&type=script&lang=ts&"
import style0 from "./VesselInfoContentLoader.vue?vue&type=style&index=0&id=f49aefb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49aefb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VRow,VSkeletonLoader})
